import axios, { isAxiosError } from "axios";

export const apiBaseUrl = "/";
// export const apiBaseUrl = "/testapp/";
//export const apiBaseUrl = "http://localhost:5244/";

const instance = axios.create({
  baseURL: apiBaseUrl,
  withCredentials: true,
});

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (isAxiosError(error)) {
      if (error.response) {
        if (
          error.response.status === 401 &&
          error.response.config.url !== "/api/auth/user"
        ) {
          window.location.href = `${apiBaseUrl}sign-in`;
        }
      }
    }

    return Promise.reject(error);
  },
);

export default instance;
